import en from './locales/en.json';
import de from './locales/de.json';

export const moneyLocales = {
  en: { money: en },
  de: { money: de },
};

export * from './money.routes';
export { SEND_MONEY_ROUTE_NAME } from './send-money/internal/send-money.constants';
export {
  BATCH_PAYMENTS_ROUTE_NAME,
  BATCH_PAYMENT_DETAILS_ROUTE_NAME,
  BATCH_PAYMENT_DRAFT_REVIEW_ROUTE_NAME,
} from './send-money/batch-payments/batch-payments.routes';
export { default as QuickTransfer } from './quick-transfer/QuickTransfer.vue';
export { default as MoneyTransactionDetailsDialog } from './transaction-details-dialog/MoneyTransactionDetailsDialog.vue';
export * from './send-money/flow-configs';
export * from './composables/useSendMoneyFlow';
export * from './composables/useWizardFlow';
export * from './send-money/composables';
export * from './send-money/result';

export { default as AddContactPage } from './send-money/add-contact/AddContactPage.vue';
export { default as RecipientDetails } from './send-money/recipient-details/RecipientDetails.vue';
export { default as Reference } from './send-money/reference/Reference.vue';
export { default as ReviewTransferDetails } from './send-money/review-transfer-details/ReviewTransferDetails.vue';
export { default as SelectRecipient } from './send-money/select-recipient/SelectRecipient.vue';
export { default as SetAmount } from './send-money/set-amount/SetAmount.vue';
